// extracted by mini-css-extract-plugin
export default {"melodyVideo":"jL-z","isFullWidth":"kL-z","landingPageVideo":"lL-z","play":"mL-z","iframeVideo":"nL-z","playHidden":"oL-z","fullwidth":"pL-z"};